import { render, staticRenderFns } from "./ConversationView.vue?vue&type=template&id=d7f920b6&scoped=true&"
import script from "./ConversationView.vue?vue&type=script&lang=js&"
export * from "./ConversationView.vue?vue&type=script&lang=js&"
import style0 from "./ConversationView.vue?vue&type=style&index=0&id=d7f920b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f920b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7f920b6')) {
      api.createRecord('d7f920b6', component.options)
    } else {
      api.reload('d7f920b6', component.options)
    }
    module.hot.accept("./ConversationView.vue?vue&type=template&id=d7f920b6&scoped=true&", function () {
      api.rerender('d7f920b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/ConversationView.vue"
export default component.exports